import React, { useEffect, useState } from 'react';
import CartIcon from '../../icons/cart';
import { useRecoilState } from 'recoil';
import { Link } from 'react-router-dom';
import { cartState } from '../../atoms';
import { updateCartState } from '../../utils';
import AddToCart from '../AddToCart';
import BookCarousel from '../BookCarousel';

export default function BookPage() {
  const [cart, setCart] = useRecoilState(cartState);

  document.title = `Life Story by McKenzie Wark | Hanuman Editions`;
  document.querySelector('meta[name="description"]').setAttribute('content', `From acclaimed theorist and trans icon McKenzie Wark, Life Story is a divulsion and revision of the author’s multiple forms.`);

  const addToCart = () => {
    let newCart = updateCartState(cart, {
      id: '9798989378067',
      priceId: 'price_1PTFJUFoScMjUSrmH8cmBjy9',
      title: 'Life Story',
      author: 'McKenzie Wark',
      image: 'LifeStory.png',
      price: 14.99,
      weight: 6,
    });
    setCart(newCart);
  }

  return (<div className='newPageContainer'>
    <div className='productContainer'>
      <div className='productImage_container  '>
        <div className='productCarousel'>
          <BookCarousel images={['../../Series-Two/McKenzieWark_01_Mockup1.webp', '../../Series-Two/McKenzieWark_01_Mockup2.webp']} start={1} />
        </div>
      </div>
      <div className='productInfo_container'>
        <div className='productInfo_inner'>
          <div className='productInfo'>
            <h1 className='productTitle'>Life Story</h1>
            <div className='productAuthor'>McKenzie Wark</div>
          </div>
          <div className='productBuyControls'>
            <AddToCart context={'product'} id={'9798989378067'} />
            <div className='productPrice'>$14.99 USD</div>
          </div>
          <div className='productExcerpt'>
            My idols are dead, and my enemies are in power. Domination co-opts language, making it almost unusable, other than by machines. We are to be ruled without even the semblance of style. I speak instead of what I have loved: writing, the city. In the end, after many diversions, this body, this world—and you.
          </div>

          <div className='productDescription'>From acclaimed theorist and trans icon McKenzie Wark, <em>Life Story</em> is a divulsion and revision of the author’s multiple forms. <em>Life Story</em> asks, "how to write not about love, but with love, in love, in form as well as content?" With an offering of lucidity amid disaster; a reinvention in the face of modernity’s unraveling. A tour of her selves, works, and worlds, <em>Life Story</em> is at once elegiac and mutinous, “an arc of history as built on an ontology of love.”
            <p>In <em>Life Story</em>, <strong>McKenzie Wark</strong> plays with her future epitaph, creating a biographical form that eludes captured data-points. But for our purposes, let’s say that this Australian-born writer and scholar is renowned for her work on media theory, critical theory, the avant-gardes, and in recent years, raving and transsexual narratives. She is a professor of Media and Cultural Studies at The New School in New York City.</p>
          </div>

          <div className='productMetadata'>
            <div>Series II</div>
            <div>Summer 2024</div>
            <div>ISBN 979-8-9893780-6-7</div>
            <div>4.125 x 2.75 x 0.54 inches</div>
            <div>80 Pages</div>
          </div>
        </div>
      </div>
    </div>
  </div>)
}